export const ONE_THOUSAND = 1000;
export const TEN_THOUSAND = 10000;
export const ONE_MILLION = 1000000;
export const ONE_BILLION = 1000000000;
